<template>
  <div class="layout-home-main">
    <div class="top-background theme-primary-background-color"></div>
    <div class="container">
      <div class="home-main-content">
        <home-main-left></home-main-left>
        <home-main-right v-bind="$attrs"></home-main-right>
      </div>
    </div>
  </div>
</template>

<script>
import HomeMainLeft from './HomeMainLeft'
import HomeMainRight from './HomeMainRight'
export default {
  name: 'HomeMain',
  components: {
    HomeMainLeft,
    HomeMainRight
  }
}
</script>

<style lang="scss">
.layout-home-main {
  padding: 30px 0 40px;
  position: relative;
  &>.top-background {
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    height: 150px;
    z-index: 1;
  }
  &>.container {
    &>.home-main-content {
      margin: 0 auto;
      position: relative;
      z-index: 2;
      display: flex;
      border-radius: 4px;
      padding: 10px 0;
    }
  }
}
@media (max-width: 640px) {
  .layout-home-main {
    &>.container {
      padding: 0;
      &>.home-main-content {
        flex-direction: column;
        border-radius: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/homeIndex/HomeMain.vue